import React from 'react';
import { connect } from 'react-redux';
import { Table, Button } from 'antd';
import { ColumnsType } from 'antd/es/table';
import intl from 'react-intl-universal';
import { getTimeByUtcOffset } from '@/utils/intl';
import { DATE_TIME_FORMAT } from '@/config';
import { initCheckRoomList } from '@/redux/actions/bill/settle';
import useInventoryPortal from '@/components/Inventory';

import { CHECK_ROOM_TYPE_MAP, CHECK_STATUS_MAP, COMPUTER_STATUS_MAP } from '../config';
import commonStyles from '../common.module.scss';
import styles from './index.module.scss';

const CheckRoom = ({ resvNo, checkRoomListLoading, checkRoomList, ...restProps }) => {
  const inventoryPortal = useInventoryPortal();

  const handleCheckRoom = (data) => {
    const { id, status } = data;
    inventoryPortal.showDrawer({
      id,
      status,
      resvNo,
      callback: () => {
        restProps.initCheckRoomList({ resvNo });
      },
    });
  };

  const checkRoomColumns: ColumnsType<any> = [
    {
      title: intl.get('bill_check_room_no'),
      dataIndex: 'roomNo',
      render: (v) => v || '-',
    },
    {
      title: intl.get('bill_check_room_entry_bill_no'),
      dataIndex: 'billRoomNo',
      render: (v) => v || '-',
    },
    {
      title: intl.get('bill_check_room_type'),
      dataIndex: 'type',
      render: (type) => (CHECK_ROOM_TYPE_MAP[type] ? CHECK_ROOM_TYPE_MAP[type] : '-'),
    },
    {
      title: intl.get('bill_check_room_start_time'),
      dataIndex: 'createTime',
      render: (val) => getTimeByUtcOffset(val, DATE_TIME_FORMAT) || '-',
    },
    {
      title: intl.get('bill_check_room_time'),
      dataIndex: 'completeTime',
      render: (val) => getTimeByUtcOffset(val, DATE_TIME_FORMAT) || '-',
    },
    {
      title: intl.get('bill_check_room_computer_status'),
      dataIndex: 'computerStatus',
      render: (val) => (val ? COMPUTER_STATUS_MAP[val] : '-'),
    },
    {
      title: intl.get('bill_check_room_status'),
      dataIndex: 'status',
      render: (val) => CHECK_STATUS_MAP[val],
    },
    {
      title: intl.get('app_table_column_action'),
      render: (_, record) => (
        <>
          {record.status === 2 ? (
            <Button type="link" style={{ paddingRight: 0 }} onClick={() => handleCheckRoom(record)}>
              {intl.get('bill_check_room_result')}
            </Button>
          ) : (
            <Button type="link" style={{ paddingRight: 0 }} onClick={() => handleCheckRoom(record)}>
              {intl.get('bill_check_room')}
            </Button>
          )}
        </>
      ),
      fixed: 'right',
      align: 'right',
    },
  ];

  return (
    <dl className={styles['settle-order-block']}>
      <dt className={commonStyles['bill-block-title']}>{intl.get('bill_check_room_list')}</dt>
      <dd>
        <Table
          rowKey="id"
          loading={checkRoomListLoading}
          dataSource={checkRoomList}
          columns={checkRoomColumns}
          pagination={false}
        />
      </dd>
    </dl>
  );
};

const mapStateToProps = (state) => {
  const { checkRoomListLoading, checkRoomList } = state.settle;
  return { checkRoomListLoading, checkRoomList };
};

export default connect(mapStateToProps, { initCheckRoomList })(CheckRoom);
